import { useWebSocket } from "app/ws/WebSocketProvider";
import { selectCompanyGuid } from "features/auth/authSlice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";


const HealthMeasurementActions = ({ patient }) => {

    const [t] = useTranslation(["global", "health"]);

    const { connectionStatus: wsStatus, client: wsClient } = useWebSocket()
    const companyGuid = useSelector(selectCompanyGuid)

    let userGuid = patient.user.guid

    const onAction = (actionType) => {
        console.log(`Required ${actionType} for ${userGuid}`)
        try {
            wsClient.publish(`company/${companyGuid}/health/${userGuid}/config`, JSON.stringify(actionType))
        } catch (err) {
            console.error(`Error trying to publish mqtt command`)
        }
    }

    return (
        <div className="card mt-2 bg-black bg-opacity-10  text-white p-4">
            <h4><i className="fa-solid fa-magnifying-glass-chart text-muted"></i> {t("property.actions")}</h4>

            <div className="h5 d-flex  align-items-start mt-2 py-2 ">
                <button className="btn btn-danger" onClick={() => onAction('REQUIRE_ECG')} >
                    <i className="fa-solid fa-heart-pulse"></i> {t("health:actions.require_ecg")}
                </button>

                <button className="btn btn-primary mx-2 " onClick={() => onAction('REQUIRE_SP02')} >
                    <i className="fa-solid fa-droplet"></i> {t("health:actions.require_sp02")}
                </button>

                <button className="btn btn-secondary mx-2 " onClick={() => onAction('REQUIRE_BIA')} >
                    <i className="fa-solid fa-chart-pie"></i> {t("health:actions.require_bia")}
                </button>
                <button className="btn btn-light mx-2 " onClick={() => onAction('SYNC')} >
                    <i className="fa-solid fa-rotate"></i> Sincronizza ora
                </button>
            </div>
        </div>
    );
}

export default HealthMeasurementActions